module.exports = "https://static.wmbcdn.com/uniweb/images/449b7a9d3961027174966af0cc6d7293.svg";